

import { Login } from '@/models/login'
import { computed, ref } from 'vue'
import { useToast } from "primevue/usetoast";
import Book from "@/models/book.models";
import BookRepository from "@/services/BookRepository";
import router from "@/router";
import {useStore} from "vuex";
import {Team} from "@/models/team.models";
import TeamRepository from "@/services/TeamRepository";
import DoctorRepository from "@/services/DoctorRepository";
import {Doctor} from "@/models/doctor.models";

export default {
  props: {
    id: Number,
  },
  setup(props){
    const login = ref({} as Login);
    const toast = useToast();
    const updateBook = ref({} as Book);
    const nameTeam = ref("");

      const valid = () => {
          return updateBook.value.doctor;
      };
    const teams = ref({} as Team[]);
    const doctors = ref({} as Doctor[]);

      TeamRepository.getTeams()
          .then((response) => {
              teams.value = response.data;
          })
          .catch();

      const store = useStore();
      if(store.state.token == ""){
          router.push({
              name: 'home'
          });
      }

      BookRepository.getById(props.id)
          .then(response => {
              updateBook.value = response.data;
              TeamRepository.getTeams()
                  .then((response) => {
                      teams.value = response.data;
                  })
                  .catch();
              teams.value.forEach(x => {if(x.code == updateBook.value.team) nameTeam.value = x.name});
              DoctorRepository.getTeams(updateBook.value.team)
                  .then((response) => {
                      doctors.value = response.data;
                  })
                  .catch();
          })
          .catch(() => {
              toast.add({
                  severity: 'error',
                  summary: 'Thất bại',
                  detail: 'Không thể tải danh sách lịch đặt chổ.',
                  life: 2000
              });
          })
          .finally(() => {
          });

      const done = () => {
          updateBook.value.checked = true;
          BookRepository.updateBook(updateBook.value)
              .then(response => {
                  toast.add({
                      severity: 'success',
                      summary: 'Thành Công',
                      detail: 'Chuyển khoa cho bệnh nhân thành công.',
                      life: 2000
                  });
                  router.push({
                      name: 'home',
                  });
              })
              .finally(()=>{
              });
      };

      const getDay = () => {
          let day = "";
          console.log("############################### Get Day AAA: " + updateBook.value.day);
        switch (updateBook.value.day) {
            case "Sunday":
                day = "Chủ nhật";
                break;
            case "Monday":
                day = "Thứ hai";
                break;
            case "Tuesday":
                day = "Thứ ba";
                break;
            case "Wednesday":
                day = "Thứ tư";
                break;
            case "Thursday":
                day = "Thứ năm";
                break;
            case "Friday":
                day = "Thứ sáu";
                break;
            case "Saturday":
                day = "Thứ bảy";
        }
        console.log("############################### Get Day BBB: " + day);
        return day;
      };

    return {
      login,
      updateBook,
      valid,
      teams,
      done,
      nameTeam,
      doctors,
      getDay
    }
  }
}

